import { render, staticRenderFns } from "./first-tips-toast.vue?vue&type=template&id=47cb9244&scoped=true&"
import script from "./first-tips-toast.vue?vue&type=script&lang=js&"
export * from "./first-tips-toast.vue?vue&type=script&lang=js&"
import style0 from "./first-tips-toast.vue?vue&type=style&index=0&id=47cb9244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb9244",
  null
  
)

export default component.exports